(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('messagingService', messagingService);

    messagingService.$inject = [
        '$http',
        '$q',
        'endPoints',
        'authorization',
        '$rootScope',
        'userService'
    ];

    function messagingService(
        $http,
        $q,
        endPoints,
        authorization,
        $rootScope,
        userService
    ) {
        var service = {
            activeOrdersCountEventName: 'ActiveOrdersCount',
			newOrdersCountEventName: 'NewOrdersCount',
			movePendingOrdersCountEventName: 'MovePendingCount',
            newOrNotificationOrdersCountEventName: 'NewOrNotificationOrdersCount',
            delayedOrdersCountEventName: 'DelayedOrdersCount',
            scheduledOrdersCountEventName: 'ScheduledOrdersCount',
            addedOrderEventName: 'AddedOrder',
            removedOrderEventName: 'RemovedOrder',
            modifiedOrderEventName: 'ModifiedOrder',
            activeOrdersUpdateEventName: 'ActiveOrdersUpdate',


            init: init,
            connect: connect
        };

        var connection;

        return service;

        function init() {
            var url = endPoints.messaging.notifications;
            url += '?';
            url += 'usuarioId=' + userService.userData.usuarioId;
            url += '&';
            url += 'empresaMasterId=' + userService.userData.empresaMasterId;
            url += '&';
            url += 'receiverId=' + userService.userData.messagingReceiverId;

            connection = new signalR.HubConnectionBuilder()
                .withUrl(url)
                .build();

            connection
                .on(service.activeOrdersCountEventName, function (message) {
                    $(window).trigger('messaging-active-orders-count', message.count);
                });

            connection
                .on(service.newOrdersCountEventName, function (message) {
                    $(window).trigger('messaging-news-orders-count', message.count);
                });

            connection
                .on(service.newOrNotificationOrdersCountEventName, function (message) {
                    $(window).trigger('messaging-news-notifications-orders-count', message.count);
                });

            connection
                .on(service.delayedOrdersCountEventName, function (message) {
                    $(window).trigger('messaging-delayed-orders-count', message.count);
                });

            connection
                .on(service.scheduledOrdersCountEventName, function (message) {
                    $(window).trigger('messaging-scheduled-orders-count', message.count);
				});

			connection
				.on(service.movePendingOrdersCountEventName, function (message) {
					$(window).trigger('messaging-movepending-orders-count', message.count);
				});

            connection
                .on(service.addedOrderEventName, function (message) {
                    $(window).trigger('added-order', message.orderId);
                });

            connection
                .on(service.removedOrderEventName, function (message) {
                    $(window).trigger('removed-order', message.orderId);
                });

            connection
                .on(service.modifiedOrderEventName, function (message) {
                    $(window).trigger('modified-order', message.orderId);
                });

            connection
				.on(service.activeOrdersUpdateEventName, function (message) {
                    $(window).trigger('active-orders-update', message);
                });

            connection
                .on('UnreadMessagesCount', function (message) {
                    $(window).trigger('messaging-unread-messages-count', message.count);
                });

            connection
                .on('UnreadMessage', function (message) {
                    $(window).trigger('messaging-unread-message', message);
                });

            connection
                .onclose(function () {
                    try {
                        $(window).trigger('login-failed');
                        connect();
                    } catch (err) {
                        setTimeout(connect, 5000);
                    }
                });
        }

		function connect() {
			return;
            connection
                .start()
                .then(function (a) {
                    $(window).trigger('login-succeed');
                }, function (reason) {
                    $(window).trigger('login-failed');
                    setTimeout(connect, 5000);
                })
                .catch(function (err) {
                });
        }
    }
})();